import '#shared/lib/time/dayjsInit';
import { CssBaseline } from '@mui/material';
import { useEffect } from 'react';

import {
  isSentryDebugEnabled,
  NetworkStateProvider,
  ThemeConnector,
} from '#shared';

import { NopEventStreamProvider } from '#processes/nop-events';

import {
  IdleUXController,
  NotificationSnackbar,
  AuthProvider,
} from '#domains/shell';

import { SentryDebugPanel } from './monitoring';
import { AppRouter } from './router';

export const App = () => {
  const showSentryDebug = isSentryDebugEnabled();

  useEffect(() => {
    const initialLoader: HTMLDivElement | null =
      document.querySelector('#onInitLoader');
    if (!initialLoader) {
      return;
    }
    const hideTimeoutId = setTimeout(() => {
      initialLoader.style.display = 'none';
    }, 250);
    return () => clearTimeout(hideTimeoutId);
  }, []);

  return (
    <AuthProvider>
      <ThemeConnector>
        <CssBaseline enableColorScheme />
        <IdleUXController />
        <NetworkStateProvider>
          <NopEventStreamProvider>
            <AppRouter />
          </NopEventStreamProvider>
        </NetworkStateProvider>
        <NotificationSnackbar />
        {showSentryDebug && <SentryDebugPanel />}
      </ThemeConnector>
    </AuthProvider>
  );
};
